import { Type } from '@angular/core';
import { SgAuxRouteBridgeService } from './aux-route-bridge.service';
import { SgAuxRouteBridgeOutlet } from './models';

/**
 * Base class for services that want to control the SgAuxRouteBridgeOutlet (SgAuxRouteBridgeOutletDirective).
 * These services will usually include helper methods that use the SgAuxRouter and provide easy access to aux-routes.
 */
export abstract class SgAuxRouteBridgeOutletController<T extends SgAuxRouteBridgeOutlet> {
  get outlet(): T | undefined {
    return this._outlet;
  }
  private _outlet: T;

  constructor(protected bridge: SgAuxRouteBridgeService, public readonly outletName: string, clz: Type<T>) {
    const subscription = bridge.events.subscribe((event) => {
      if (event.kind === 'register' && event.outlet.name === outletName) {
        if (event.outlet instanceof clz) {
          this._outlet = event.outlet as T;
        } else {
          throw new Error(
            `Invalid outlet definition for "${this.outletName}", outlet is not an instance of "${clz.name}".`
          );
        }
        subscription.unsubscribe();
      }
    });
  }
}
